'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');
const ColorPanel = require('./../../../../bundles/design/repository/DesignRepository');

let ElementClass = require('./../../elementClass');
let ProtocolElement = require('./../url/Element/protocol');

let tpl = require('./template/wrapper.hbs');
let btnTpl = {
  'with_button': require('./template/with_button.hbs'),
  'image_link': require('./template/image_link.hbs'),
};

FormBuilder.register('imageLink', function(config) {
  let self = {};
  let $select;
  let $form;
  let $element = jQuery(tpl());

  const createColors = function() {
    ColorPanel.getAllColors().done(function(data) {
      let $wrap = $form.find('.color-wrapper');
      let colors = data.map((element) => element.id);

      colors.forEach(function(color, index) {
        let $bgColor = jQuery(`<div class="has-bg-color ${color}"></div>`);
        let $button = jQuery(`<button data-value="${color}" type="button" class="btn btn-default has-bg-color ${color}"></button>`);

        jQuery('body').append($bgColor);
        $button.css('background-color', $bgColor.css('background-color'));
        $bgColor.remove();

        if (!index) {
          $button.addClass('selected');
        }

        $wrap.append($button).append('&nbsp;');
      });

      $form.find('[data-key]').on('click', 'button', function() {
        jQuery(this).addClass('selected').siblings().removeClass('selected');
      });
    });
  };

  /**
   * Add URL protocol template.
   */
  const addURLProtocol = function() {
    let $inputGroupProtocol = $form.find('div.cloud-group div.input-group-protocol');
    $inputGroupProtocol.prepend(ProtocolElement.getTemplate());
  };

  self = new ElementClass(config);

  self.render = function() {
    $form = $element.find('form');
    $select = $element.find('select.choice-list');

    $select.on('change', function() {
      let option = jQuery(this).find('option:selected').val();

      $form.html('');

      if (btnTpl[option]) {
        $form.append(btnTpl[option]());

        if (option === 'with_button') {
          createColors();
        }

        if (option === 'image_link') {
          addURLProtocol();
        }

        self.populateForm();
      }
    });

    if (config.value.link) {
      $select.val(config.value.link).change();
    }

    return $element;
  };

  self.populateForm = function() {
    if (config.value.options) {
      $form.find('input[type="text"], checkbox, select').each(function() {
        let $element = jQuery(this);
        let value = config.value.options[$element.attr('name')];
        if (value) {
          $element.val($element.attr('name') === 'url' ? ProtocolElement.getURLValue(value) : value);
        }

        if ($element.attr('name') === 'protocol' && config.value.options['url']) {
          $element.val(ProtocolElement.getValue(config.value.options['url']));
        }
      });

      $form.find('input[type="radio"]').each(function() {
        let $current = jQuery(this);
        let name = $current.attr('name');
        let value = config.value.options[name];

        if ($current.val() === value) {
          $current.prop('checked', true);
        }
      });

      $form.find('input[type="checkbox"]').each(function() {
        const $current = jQuery(this);
        const name = $current.attr('name');
        const value = config.value.options[name];

        if (value) {
          $current.prop('checked', true);
        }
      });

      $form.find('[data-key]').each(function() {
        let $current = jQuery(this);
        let key = $current.attr('data-key');

        $current.find(`[data-value="${config.value.options[key]}"]`).addClass('selected').siblings().removeClass('selected');
      });
    }
  };

  self.getData = function() {
    let data = {};

    data.link = $select.find('option:selected').val();
    data.options = $form.serializeArray().reduce(function(obj, item) {
      obj[item.name] = item.value;

      return obj;
    }, {});

    $form.find('[data-key]').each(function() {
      let $current = jQuery(this);
      let $selected = $current.find('.selected');

      data.options[$current.attr('data-key')] = $selected.attr('data-value');
    });

    $form.find('input[type="radio"]').each(function() {
      let $input = jQuery(this);

      if ($input.is(':checked')) {
        data.options[$input.attr('name')] = $input.val();

        return false;
      }
    });

    $form.find('input[type="checkbox"]').each(function() {
      const $input = jQuery(this);

      if ($input.is(':checked')) {
        data.options[$input.attr('name')] = true;
      }
    });

    if (data.options.url) {
      data.options.url = data.options.protocol || '' || null ?
        data.options.protocol + data.options.url : data.options.url;
    }

    delete data.options.protocol;

    return data;
  };

  return self;
});
